export interface ITypographyVariables {
  defaultFontFamily: string
  headingFontFamily: string
  baseFontSize: number
  baseLineHeight: number
}

const typographyVariables: ITypographyVariables = {
  defaultFontFamily: 'SB Sans Interface, sans-serif',
  headingFontFamily: 'SB Sans Display, sans-serif',
  baseFontSize: 14,
  baseLineHeight: 20,
}

export default typographyVariables
